import { Copy, Eye, EyeOff, Trash2 } from "lucide-react";
import type { EditorState } from "../useEditorState";

interface SectionActionsProps {
  editor: EditorState;
  sectionId: string;
  isHidden: boolean;
}

/**
 * Duplicate / hide / delete actions at the bottom of the inspector.
 */
export function SectionActions({
  editor,
  sectionId,
  isHidden,
}: SectionActionsProps) {
  const btnBase =
    "border-0 bg-transparent text-left text-[12.5px] font-semibold text-ink-4 px-[9px] py-[7px] rounded-[8px] flex items-center gap-2 hover:bg-paper-2 hover:text-ink-2 transition-colors w-full";

  return (
    <>
      <hr className="border-0 border-t border-paper-2 my-5" />
      <div className="flex flex-col gap-2">
        <button
          type="button"
          className={btnBase}
          onClick={() => editor.duplicateSection(sectionId)}
        >
          <Copy size={13.5} strokeWidth={1.6} />
          Duplicate section
        </button>
        <button
          type="button"
          className={btnBase}
          onClick={() => editor.toggleSectionVisibility(sectionId)}
        >
          {isHidden ? (
            <EyeOff size={13.5} strokeWidth={1.7} />
          ) : (
            <Eye size={13.5} strokeWidth={1.7} />
          )}
          {isHidden ? "Show to visitors" : "Hide from visitors"}
        </button>
        <button
          type="button"
          className={`${btnBase} !text-rust hover:!bg-rust-s`}
          onClick={() => editor.removeSection(sectionId)}
        >
          <Trash2 size={13.5} strokeWidth={1.7} />
          Delete section
        </button>
      </div>
    </>
  );
}
